import { Grid, Typography } from "@mui/material";
import Appointment from "../interface/appointment";

const RenderCoachFullName = ({
  appointment,
}: {
  appointment: Appointment;
}): React.JSX.Element => (
  <Grid
    item
    xs={12}
    sm={6}
    md={appointment.isSpeedcoaching ? 4 : 3}
    sx={{
      display: "flex",
      alignItems: "center",
    }}
  >
    <Typography variant="body1" color="initial">
      {appointment.coachFullName === null
        ? "Termin ist frei"
        : appointment.coachFullName}
    </Typography>
  </Grid>
);

export default RenderCoachFullName;
